import Image from 'next/image';
import { useEffect, useState } from 'react';

import businessConfig from '@/businessConfig';
import SafePurchasePopUp from '@/components/SafePurchasePopUp';

import CertifyIcon from '../../../public/icons/certify-blue.svg';
import ChevronRight from '../../../public/icons/chevron-right-blue.svg';

import styles from './styles.module.scss';

interface Props {
  onPopUpVisibilityChange?: (value: boolean) => void;
  storeId?: string;
}

const ProductSafePurchaseBadge = ({
  onPopUpVisibilityChange,
  storeId,
}: Props) => {
  const [isPopUpVisible, setIsPopUpVisible] = useState(false);
  const handleOpen = () => setIsPopUpVisible(true);
  const handleClose = () => setIsPopUpVisible(false);

  const isReturnDisabled =
    storeId && businessConfig.disabledReturnsStores.has(storeId);
  const attributes = [
    'Ochrona Kupującego',
    'Bezpieczna dostawa',
    ...(isReturnDisabled ? [] : ['14 dni na zwrot']),
  ];

  useEffect(() => {
    onPopUpVisibilityChange?.(isPopUpVisible);
  }, [isPopUpVisible, onPopUpVisibilityChange]);

  return (
    <div className={styles.container}>
      {isPopUpVisible && <SafePurchasePopUp onClose={handleClose} />}
      <button className={styles.openButton} onClick={handleOpen}>
        <Image
          src={CertifyIcon}
          alt="Ikona certyfikatu"
          width={20}
          height={20}
        />
        Patyna.pl gwarantuje bezpieczne zakupy
        <Image
          className={styles.chevronRight}
          src={ChevronRight}
          alt="Ikona strzałki w prawo"
          width={20}
          height={20}
        />
      </button>
      <ul className={styles.list}>
        {attributes.map((attribute, index) => (
          <li key={index} className={styles.listItem}>
            {attribute}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductSafePurchaseBadge;
